import './user-menu.scss';
import { RootState } from 'types';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { actions } from 'redux/reducers';
import ToggleSwitch from 'components/toggle-switch'

function UserMenu({
    open,
    setOpen
} : {
    open: boolean,
    setOpen: Dispatch<SetStateAction<boolean>>
}) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const state = useSelector((state:RootState) => state);
    const [themeToggle, setThemeToggle] = useState(false);

    const logout = () => {
        localStorage.removeItem('AccessToken');
        dispatch(actions.user.set(null));
        navigate('/login');
    }

    useEffect(() => {
        if (localStorage.Theme == 'dark') {
            setThemeToggle(true);
        }
        else {
            setThemeToggle(false);
        }
      }, [dispatch])

    useEffect(() => {
        if (themeToggle) {
            dispatch(actions.theme.set('dark'));
            localStorage.Theme = 'dark';
        }
        else {
            dispatch(actions.theme.set('light'));
            localStorage.Theme = 'light';
        }
      }, [themeToggle])

    return (
        <div className={`user-menu ${open ? 'open' : ''}`} onClick={() => setOpen(false)}>
            <div className="user-menu-content">
                <div className="user-menu-content-header">
                    <i className="fal fa-user"></i>
                    <p>{state.user?.FirstName} {state.user?.LastName}</p>
                </div>
                <div className='menu-option'>
                    <span className='label'>Dark Mode</span>
                    <ToggleSwitch id='dark-mode' checked={themeToggle} onChange={setThemeToggle} name='dark-mode' small={true} disabled={false} />
                </div>
                <button onClick={logout}>Logout</button>
            </div>
        </div>
    )
}

export default UserMenu;